const map = [{
    types: ["task-activity", "task-appointment", "task-search", "task-standard-approval", "task-assessment", "task-service-request", "vm-pl-investigation"],
    route: { name: "task-detail", params: {} }
}, {
    types: ["vm-instruction-dispute-claimant-pd"],
    route: { name: "instruction-detail", params: {} }
}]

export default map;